import React from "react";
import "./Variables.scss";

const BorderLine = () => {
  return <div className="border" />;
};

export default BorderLine;
